var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-calendar-header" }, [
    _c("div", { staticClass: "header-left" }, [_vm._t("header-left")], 2),
    _c("div", { staticClass: "header-center is-flex is-centered" }, [
      _c(
        "span",
        {
          staticClass: "prev-month title is-4",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goPrev($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.leftArrow))]
      ),
      _c("span", { staticClass: "title is-uppercase" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "span",
        {
          staticClass: "next-month title is-4",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goNext($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.rightArrow))]
      )
    ]),
    _c("div", { staticClass: "header-right" }, [_vm._t("header-right")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }